module.exports = "/_next/static/images/b25ff539c84bfe5ebfc157b65d2548bf-google-pay.png.webp";